/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_PriorityInputs */

const en_prop_priority = /** @type {(inputs: Prop_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const de_prop_priority = /** @type {(inputs: Prop_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorität`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Prop_PriorityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_priority = /** @type {((inputs?: Prop_PriorityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_PriorityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_priority(inputs)
	return en_prop_priority(inputs)
});